/* Lupin Gold upsell prices from the real Deals function (Enkindle 15/10/2026).

   The drawer and /cart rows are first rendered by Liquid from the live variant price
   and the amounts in the mini-cart settings. This file then replaces every shown
   price with what checkout will actually charge: for each row it builds the current
   cart (from /cart.js) plus the offered item, asks the Storefront API to price that
   cart (cartCreate runs the Lupin Gold Deals discount function), and writes back the
   real line prices. Nothing here holds a typed price or discount amount.

   Markup hooks (snippets/cart-upsell.liquid):
     .lg-upsell__row[data-lg-upsell-row]   row; bulk rows add data-lg-bulk, gift rows data-lg-gift
     [data-lg-upsell-now] [data-lg-upsell-was] [data-lg-upsell-badge]  price parts
     [data-lg-saving]   saving amount inside the sub line
     [data-lg-pct]      percentage inside the bulk sub line
     [data-lg-unlock][data-products="id,id"]  unlock amount for those products
   If the API call fails, the Liquid values stay. */
;(function () {
  if (window.lgUpsellPriceReady) { return; }
  window.lgUpsellPriceReady = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var API = root + 'api/2026-07/graphql.json';
  var COUNTRY = (window.Shopify && Shopify.country) || 'AU';
  var Q = 'mutation($l:[CartLineInput!],$c:CountryCode){cartCreate(input:{lines:$l,buyerIdentity:{countryCode:$c}}){' +
    'cart{lines(first:100){nodes{quantity merchandise{...on ProductVariant{id}} cost{totalAmount{amount} subtotalAmount{amount}}}}}' +
    'userErrors{message}}}';

  function fmt() {
    return (window.themeVariables && themeVariables.settings && themeVariables.settings.moneyFormat) || '${{amount}}';
  }
  function money(cents, dropZeros) {
    cents = Math.round(cents);
    var n = (Math.round(cents) / 100).toFixed(2);
    if (dropZeros) { n = n.replace(/\.00$/, ''); }
    var parts = n.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt().replace(/\{\{\s*\w+\s*\}\}/, parts.join('.'));
  }
  function gid(id) { return 'gid://shopify/ProductVariant/' + id; }
  function num(gidStr) { return String(gidStr).split('/').pop(); }

  var cache = {};
  // setQty (26/10): price the cart with that variant at exactly setQty instead of +1.
  function simulate(baseLines, extraVariant, setQty) {
    var lines = baseLines.map(function (l) { return { merchandiseId: l.merchandiseId, quantity: l.quantity }; });
    if (extraVariant) {
      var hit = lines.filter(function (l) { return l.merchandiseId === gid(extraVariant); })[0];
      if (setQty) {
        if (hit) { hit.quantity = setQty; } else { lines.push({ merchandiseId: gid(extraVariant), quantity: setQty }); }
      } else if (hit) { hit.quantity += 1; } else { lines.push({ merchandiseId: gid(extraVariant), quantity: 1 }); }
    }
    var key = JSON.stringify(lines);
    if (!cache[key]) {
      cache[key] = fetch(API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ query: Q, variables: { l: lines, c: COUNTRY } })
      })
        .then(function (r) { if (!r.ok) { throw new Error('sf ' + r.status); } return r.json(); })
        .then(function (j) {
          var cart = j && j.data && j.data.cartCreate && j.data.cartCreate.cart;
          if (!cart) { throw new Error('no cart'); }
          var byVariant = {};
          cart.lines.nodes.forEach(function (n) {
            var id = num(n.merchandise.id);
            var v = byVariant[id] || (byVariant[id] = { qty: 0, total: 0, subtotal: 0 });
            v.qty += n.quantity;
            v.total += Math.round(parseFloat(n.cost.totalAmount.amount) * 100);
            v.subtotal += Math.round(parseFloat(n.cost.subtotalAmount.amount) * 100);
          });
          return byVariant;
        })
        .catch(function (e) { delete cache[key]; throw e; });
    }
    return cache[key];
  }

  function cartState() {
    return fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var merged = {};
        cart.items.forEach(function (i) {
          var m = merged[i.variant_id] || (merged[i.variant_id] = { merchandiseId: gid(i.variant_id), quantity: 0 });
          m.quantity += i.quantity;
        });
        return { cart: cart, lines: Object.keys(merged).map(function (k) { return merged[k]; }) };
      });
  }

  function activeVariant(row) {
    var choice = row.querySelector('.lg-upsell__choice-input:checked');
    var field = choice
      ? row.querySelector('.lg-upsell__size[data-for="' + choice.value + '"], .lg-upsell__single[data-for="' + choice.value + '"]')
      : row.querySelector('.lg-upsell__size:not([disabled]), .lg-upsell__single:not([disabled])');
    var btn = row.querySelector('.lg-upsell__add');
    return (field && field.value) || (btn && btn.getAttribute('data-variant-id'));
  }

  function setText(el, text) { if (el && el.textContent !== text) { el.textContent = text; } }
  function show(el, on) { if (el) { el.hidden = !on; } }

  function priceRow(row, state) {
    var vid = activeVariant(row);
    if (!vid) { return Promise.resolve(); }
    // Price the cart as it is and with one more of this item. The row shows the
    // difference on this variant's line, i.e. the price of ONE more, even when
    // the variant is already in the cart (fix 15/10: it showed the whole line).
    return Promise.all([simulate(state.lines, null), simulate(state.lines, vid)]).then(function (both) {
      var res = both[1];
      var line = res[vid];
      if (!line || !line.qty) { return; }
      var had = both[0][vid] || { qty: 0, total: 0, subtotal: 0 };
      var now = row.querySelector('[data-lg-upsell-now]');
      var was = row.querySelector('[data-lg-upsell-was]');
      var wasWrap = was && was.closest('.lg-upsell__was');
      var badge = row.querySelector('[data-lg-upsell-badge]');

      if (row.hasAttribute('data-lg-bulk')) {
        // Price per pack once the extra pack is in: the function's real tier.
        var each = line.total / line.qty;
        var full = line.subtotal / line.qty;
        var pct = line.subtotal > 0 ? Math.round((1 - line.total / line.subtotal) * 100) : 0;
        if (row.hasAttribute('data-lg-gift')) {
          setText(now, money(full));
          return;
        }
        if (now) { now.innerHTML = ''; now.appendChild(document.createTextNode(money(each))); var s = document.createElement('small'); s.textContent = ' each'; now.appendChild(s); }
        setText(was, money(full));
        show(wasWrap, pct > 0);
        row.querySelectorAll('[data-lg-pct]').forEach(function (p) { setText(p, String(pct)); });
        setText(badge, 'Save ' + pct + '%');
        show(badge, pct > 0);
        return;
      }

      // Single item rows (towel, tee, unlock packs): the one item being offered.
      var nowC = line.total - had.total, fullC = line.subtotal - had.subtotal, saving = fullC - nowC;
      // A towel/tee offer only stands while the function still discounts the next
      // one (tees: fewer tees than protein packs). If it would not, drop the row.
      if (/^rule-/.test(row.getAttribute('data-lg-upsell-row') || '')) {
        row.hidden = !(saving > 0);
        if (row.hidden) { return; }
      }
      setText(now, nowC === 0 ? 'FREE' : money(nowC));
      if (was) { setText(was, money(fullC)); }
      show(wasWrap, saving > 0);
      if (badge) {
        setText(badge, nowC === 0 ? 'Free' : 'Save ' + money(saving, true));
        show(badge, saving > 0);
      }
      row.querySelectorAll('[data-lg-saving]').forEach(function (s) { setText(s, money(saving, true)); });
    });
  }

  function priceUnlock(panel, state) {
    var spans = panel.querySelectorAll('[data-lg-unlock]');
    var pack = panel.querySelector('[data-lg-upsell-row="unlock-1"] .lg-upsell__add');
    if (!spans.length || !pack) { return Promise.resolve(); }
    var packVid = pack.getAttribute('data-variant-id');
    // Price the cart as it is and with the pack added, both from the function, and
    // report the drop on the towel/tee lines.
    return Promise.all([simulate(state.lines, null), simulate(state.lines, packVid)]).then(function (both) {
      var base = both[0], res = both[1];
      spans.forEach(function (span) {
        var ids = (span.getAttribute('data-products') || '').split(',');
        var before = 0, after = 0, seen = {};
        state.cart.items.forEach(function (i) {
          if (ids.indexOf(String(i.product_id)) === -1 || seen[i.variant_id]) { return; }
          seen[i.variant_id] = 1;
          if (base[i.variant_id]) { before += base[i.variant_id].total; }
          if (res[i.variant_id]) { after += res[i.variant_id].total; }
        });
        var saving = before - after;
        if (saving > 0) { setText(span, money(saving, true)); }
      });
    });
  }

  function sumTotal(res) {
    var t = 0;
    Object.keys(res).forEach(function (k) { t += res[k].total; });
    return t;
  }

  // Bundle offer (no protein in the cart): "Bundle total" on each pack row = the whole
  // cart with that pack added, as the function prices it.
  function priceBundleTotals(panel, state) {
    var jobs = [];
    panel.querySelectorAll('[data-lg-bundle-total]').forEach(function (el) {
      var row = el.closest('.lg-upsell__row');
      var btn = row && row.querySelector('.lg-upsell__add');
      if (!btn) { return; }
      jobs.push(simulate(state.lines, btn.getAttribute('data-variant-id')).then(function (res) {
        setText(el, money(sumTotal(res)));
      }).catch(function () {}));
    });
    return Promise.all(jobs);
  }

  // Protein tiers (26/10): each tier = the cart with this pack at that quantity
  // (the current tier at the real quantity). Price each, Save %, or Free towel when
  // the function gives the towel in place of the %, and "+ free shipping" on a tier
  // that takes the cart over the threshold.
  function priceTiers(panel, state) {
    var jobs = [];
    panel.querySelectorAll('[data-lg-tiers]').forEach(function (block) {
      var vid = block.getAttribute('data-variant-id');
      var have = parseInt(block.getAttribute('data-qty'), 10) || 0;
      var thr = parseInt(block.getAttribute('data-free-ship'), 10) || 0;
      var baseP = simulate(state.lines, null);
      block.querySelectorAll('[data-lg-tier-qty]').forEach(function (tier) {
        var tq = parseInt(tier.getAttribute('data-lg-tier-qty'), 10);
        var q = (tier.classList.contains('is-current') && have > tq) ? have : tq;
        jobs.push(Promise.all([baseP, simulate(state.lines, vid, q)]).then(function (both) {
          var base = both[0], res = both[1], line = res[vid];
          if (!line || !line.qty) { return; }
          var each = line.total / line.qty;
          var pct = line.subtotal > 0 ? Math.round((1 - line.total / line.subtotal) * 100) : 0;
          var gift = false;
          // The gift replaces the %, so it only counts when this pack line has no % off.
          Object.keys(res).forEach(function (k) {
            if (pct === 0 && k !== vid && res[k].subtotal > 0 && res[k].total === 0) { gift = true; }
          });
          setText(tier.querySelector('[data-lg-tier-each]'), money(each, true));
          var badge = tier.querySelector('[data-lg-tier-badge]');
          if (badge) {
            if (gift) { setText(badge, 'Free towel'); badge.classList.remove('is-none'); }
            else if (pct > 0) { setText(badge, 'Save ' + pct + '%'); badge.classList.remove('is-none'); }
            else { setText(badge, 'Full price'); badge.classList.add('is-none'); }
          }
          var giftNote = tier.querySelector('[data-lg-tier-gift]');
          if (giftNote && gift) { giftNote.hidden = true; }
          var ship = tier.querySelector('[data-lg-tier-ship]');
          if (ship) { ship.hidden = !(thr > 0 && q > have && sumTotal(base) < thr && sumTotal(res) >= thr); }
        }).catch(function () {}));
      });
    });
    return Promise.all(jobs);
  }

  var running = new WeakMap();
  function pricePanel(panel) {
    if (!panel || !window.fetch) { return; }
    if (running.get(panel)) { return; }
    running.set(panel, true);
    cartState()
      .then(function (state) {
        var jobs = [priceUnlock(panel, state), priceBundleTotals(panel, state), priceTiers(panel, state)];
        panel.querySelectorAll('.lg-upsell__row').forEach(function (row) { jobs.push(priceRow(row, state).catch(function () {})); });
        return Promise.all(jobs);
      })
      .catch(function () {})
      .then(function () { running.delete(panel); panel.setAttribute('data-lg-priced', ''); });
  }

  function scan() {
    document.querySelectorAll('[data-lg-upsell]:not([data-lg-priced])').forEach(pricePanel);
  }
  // Throttle, not debounce: a page with a running ticker adds nodes all the time and
  // a debounce would never fire.
  var pending = false;
  function soon() {
    if (pending) { return; }
    pending = true;
    setTimeout(function () { pending = false; scan(); }, 150);
  }

  // Drawer re-renders by innerHTML and /cart lifts a fresh panel: price whatever appears.
  // Watch only those two roots, so the rest of the page's DOM churn costs nothing.
  function watch() {
    var roots = [document.getElementById('mini-cart'), document.querySelector('[data-lg-cart-upsell]')].filter(Boolean);
    var obs = new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].addedNodes.length) { soon(); return; }
      }
    });
    roots.forEach(function (r) { obs.observe(r, { childList: true, subtree: true }); });
  }
  document.addEventListener('cart:refresh', function () { setTimeout(soon, 900); });
  document.addEventListener('lg-upsell:added', function () { setTimeout(soon, 900); });

  // Choosing a different tee or size: price that row again.
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el.closest) { return; }
    var row = el.closest('.lg-upsell__row');
    if (!row || !(el.matches('.lg-upsell__choice-input') || el.matches('.lg-upsell__size'))) { return; }
    setTimeout(function () {
      cartState().then(function (state) { return priceRow(row, state); }).catch(function () {});
    }, 0);
  });

  function start() { watch(); scan(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
  window.lgUpsellPrice = { scan: function () { document.querySelectorAll('[data-lg-upsell]').forEach(function (p) { p.removeAttribute('data-lg-priced'); }); scan(); } };
})();
